import { ContractInterface } from '../interfaces/contract';
import { Checklist } from "./checklist";
import { ContractFounder } from "./contractFounder";
import { Inspection } from "./inspection";

export class Contract implements ContractInterface {
    id_contract?: number;
    fk_id_checklist: number;
    checklist: Checklist;
    fk_id_contract_founder: number;
    contract_founder: ContractFounder;
    inspections: Array<Inspection>;
    lot: string;
    start: Date;
    end: Date;
    name: string;
    code: string;
    subject: string;

    constructor() {
        this.fk_id_checklist = 0;
        this.checklist = new Checklist();
        this.fk_id_contract_founder = 0;
        this.contract_founder = new ContractFounder();
        this.inspections = [];
        this.lot = '';
        this.start = new Date;
        this.end = new Date;
        this.name = '';
        this.code = '';
        this.subject = '';
    }
}
